import { render, staticRenderFns } from "./teamSLA.vue?vue&type=template&id=3cfa71c8&scoped=true&"
import script from "./teamSLA.vue?vue&type=script&lang=js&"
export * from "./teamSLA.vue?vue&type=script&lang=js&"
import style0 from "./teamSLA.vue?vue&type=style&index=0&id=3cfa71c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfa71c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cfa71c8')) {
      api.createRecord('3cfa71c8', component.options)
    } else {
      api.reload('3cfa71c8', component.options)
    }
    module.hot.accept("./teamSLA.vue?vue&type=template&id=3cfa71c8&scoped=true&", function () {
      api.rerender('3cfa71c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/teamSLA.vue"
export default component.exports